// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38G10","colBig":"styles_colBig__35fOO","colSmall":"styles_colSmall__19_jU"};